import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormGroup,
  NavItem,
  Nav,
  NavLink,
  TabContent,
  TabPane,
  Button,
  CardTitle,
} from "reactstrap";
import "moment-timezone";
import ReactTable from "components/ReactTable/ReactTable.js";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useMemo, useState, useEffect, useContext } from "react";
import {
  NavLink as DomNavLink,
  useHistory,
  useLocation,
} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import { ToastContainer, toast } from "react-toastify";
import Moment from "moment";
import ImageGallery from "react-image-gallery";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { FaCheckCircle, FaQuestionCircle } from "react-icons/fa";
import { BsFillXCircleFill } from "react-icons/bs";

const EndpointDetails = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);

  const [horizontalTabs, setHorizontalTabs] = useState("alarms");

  const [endpointId, setEndpointId] = useState(
    location.state ? location.state.endpointId : "",
  );

  const [subscriberId, setSubscriberId] = useState(
    location.state ? location.state.subscriberId : "",
  );
  const [details, setDetails] = useState();
  const [alert, setAlert] = useState(null);
  const [settings, setSettings] = useState();
  const [imageSrc, setImageSrc] = useState([]);
  const [powerCycleEndpointId, setPowerCycleEndpointId] = useState(null);
  const [rebootEndpointId, setRebootEndpointId] = useState(null);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.endpoints.details.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    fetchData("manual");

    const intervalIDValue = setInterval(() => {
      fetchData("auto");
    }, 10000);

    return () => {
      clearInterval(intervalIDValue);
    };
  }, []);

  const fetchData = (mode) => {
    fetch("/api/v1/endpoint/details", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        endpointId: endpointId,
        subscriberId: subscriberId,
        mode: mode,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.data) {
          setDetails(actualData.data);
        }
        if (actualData.settings) {
          setSettings(actualData.settings);
        }

        const loadImage = async (pos) => {
          try {
            const imageModule = await import(
              `../../../assets/img/devices/${actualData.data.modelType}/${pos}.png`
            );
            return imageModule.default;
          } catch (Exception) {
            return null;
          }
        };

        const loadImages = async () => {
          const promises = [];
          for (var x = 1; x <= 9; x++) {
            promises.push(loadImage(x));
          }

          const images = await Promise.all(promises);
          const finalImages = [];
          images.map((image) => {
            if (image != null) {
              finalImages.push({ original: image, thumbnail: image });
            }
          });
          setImageSrc(finalImages);
        };

        loadImages();
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const openDevicePortal = () => {
    fetch("/api/v1/device/url", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: details.deviceSerialNumber,
        virtuosoPort: window.location.port,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        window.open(actualData.data.url, "_blank", "noreferrer");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const redirectToDeviceDetails = () => {
    const location = {
      pathname: "/admin/devices/details",
      state: {
        value: details.deviceSerialNumber,
      },
    };
    history.push(location);
  };

  const redirectToConfigurationList = () => {
    const location = {
      pathname: "/admin/configurations/list",
      state: { serialNumber: details.deviceSerialNumber },
    };
    history.push(location);
  };

  const redirectToSubscriberEditPage = () => {
    const location = {
      pathname: "/admin/subscribers/edit",
      state: {
        value: details.subscriberId,
      },
    };
    history.push(location);
  };

  const alertPowerCycle = (id) => {
    setPowerCycleEndpointId(id);
    setAlert("cyclePower");
  };

  const alertReboot = (id) => {
    setRebootEndpointId(id);
    setAlert("reboot");
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const powercycle = () => {
    hideAlert();
    setShowLoading(true);
    fetch("/api/v1/endpoint/powercycle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: powerCycleEndpointId,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status != "200") {
          toast.error(
            "A problem occured while doing the power cycle: " +
              actualData.error_code[0],
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          toast.success("Power Cycle done successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const reboot = () => {
    hideAlert();
    setShowLoading(true);
    fetch("/api/v1/endpoint/reboot", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("token"),
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: rebootEndpointId,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status != "200") {
          toast.error(
            "A problem occured while doing the reboot: " +
              actualData.error_code[0],
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          toast.success("Reboot in progress", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          fetchData("auto");
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const getUplinkPort = () => {
    if (!details) {
      return "NONE";
    }

    if (details.doubleTagging && details.uplinkPort == "NONE") {
      return "Default (10G-1)";
    } else {
      return details.uplinkPort;
    }
  };

  const getDeviceLastSeenInfo = (lastSeenValue) => {
    var serverTime = new Date().getTime();
    if (settings.server_time) {
      serverTime = new Date(settings.server_time).getTime();
    }

    var delay = Math.floor(
      (serverTime - new Date(lastSeenValue).getTime()) / 60000,
    );

    // Set the right background color base on the delay or the status
    var color = "";
    if (delay >= settings.device_minutes_considered_active) {
      color = "rgba(232, 80, 77, 1)"; // Muted Red
    } else if (delay >= settings.device_minutes_warning_active) {
      color = "rgba(240, 205, 102, 1)"; // Soft Yellow
    }
    return (
      <div>
        <span style={{ backgroundColor: color }}>
          {settings.general_convert_date_with_user_timezone === "true"
            ? Moment(lastSeenValue)
                .tz(settings.user_timezone)
                .format("yy-MM-DD hh:mm a")
            : Moment.utc(lastSeenValue).format("yy-MM-DD hh:mm a")}
        </span>
      </div>
    );
  };

  const showEndpointStatusIcon = (details) => {
    var state = details ? details.state : "";
    var reboot = details ? details.reboot : "";
    var icon = <FaCheckCircle className="text-primary tableIconFontSize" />;
    if (state == "Offline" || state == "Not Detected") {
      icon = <FaQuestionCircle className="text-danger tableIconFontSize" />;
    } else if (state == "Not Configured") {
      icon = (
        <FaCog
          className="tableIconFontSize"
          style={{ color: "rgba(79, 129, 189, 1)" }}
        />
      );
    } else if (state == "Auto Configure") {
      icon = <FaQuestionCircle className="text-warning tableIconFontSize" />;
    } else if (state == "Wrong Port") {
      icon = <BsFillXCircleFill className="text-danger tableIconFontSize" />;
    } else if (reboot == true) {
      icon = <FaCheckCircle className="text-warning tableIconFontSize" />;
    }

    return icon;
  };

  const showDeviceStatusIcon = (lastSeenValue) => {
    var serverTime = new Date().getTime();
    if (settings.server_time) {
      serverTime = new Date(settings.server_time).getTime();
    }

    var delay = Math.floor(
      (serverTime - new Date(lastSeenValue).getTime()) / 60000,
    );

    var icon = <FaCheckCircle className="text-primary tableIconFontSize" />;
    if (delay >= settings.device_minutes_considered_active) {
      icon = <BsFillXCircleFill className="text-danger tableIconFontSize" />;
    }
    return icon;
  };

  const alarmsColumns = useMemo(
    () => [
      {
        Header: "Severity",
        accessor: "severity",
        sortBy: "severity",
        Cell: (props) => {
          let value = props.value.toUpperCase();

          // Set the right background color base on the delay
          var color = "";
          if (value == "CR") {
            color = "rgba(232, 80, 77, 1)"; // Muted Red
          } else if (value == "MJ") {
            color = "rgba(237, 145, 49, 1)"; // Soft Orange
          } else if (value == "MN") {
            color = "rgba(240, 205, 102, 1)"; // Soft Yellow
          } else if (value == "NA") {
            color = "rgba(149, 179, 215, 1)"; // Light Steel Blue
          }
          return (
            <div style={{ backgroundColor: color, width: "100%" }}>{value}</div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Condition",
        accessor: "condition",
        sortBy: "condType",
        flex: "1 1 0",
      },
      {
        Header: "Service Affecting",
        accessor: "serviceAffecting",
        sortBy: "servAff",
        Cell: (props) => {
          return <span> {props.value}</span>;
        },
        flex: "1 1 0",
      },
      {
        Header: "Description",
        accessor: "description",
        sortBy: "ifDescr",
        flex: "1 1 0",
      },
      {
        Header: "Occured",
        accessor: "occured",
        sortBy: "occurTime",
        Cell: (props) => {
          return (
            <div>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
            </div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Received",
        accessor: "received",
        sortBy: "creationDate",
        Cell: (props) => {
          return (
            <div>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
            </div>
          );
        },
        flex: "1 1 0",
      },
    ],
    [],
  );

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert == "cyclePower" ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to cycle PoE Power for this endpoint ?"
            onConfirm={() => {
              powercycle();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          ></ReactBSAlert>
        ) : (
          ""
        )}

        {alert == "reboot" ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to reboot this endpoint ?"
            onConfirm={() => {
              reboot();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          ></ReactBSAlert>
        ) : (
          ""
        )}

        <Row>
          <Col>
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/endpoints/list",
                      }}
                    >
                      Endpoints
                    </DomNavLink>
                    {details ? <i>&lt;{details.confEndpointName}&gt;</i> : ""}
                  </BreadcrumbItem>
                  <BreadcrumbItem>Details</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {" "}
            <Card>
              <CardBody>
                <Row>
                  {imageSrc.length > 0 ? (
                    <Col md="4" className="border-end">
                      <ImageGallery items={imageSrc} showPlayButton={false} />
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col
                    md={imageSrc.length > 0 ? 8 : 12}
                    className="d-flex flex-column"
                    style={{ minHeight: "100%" }}
                  >
                    <div className="flex-grow-1">
                      <h5>GAM Details</h5>
                      <Form>
                        <Row>
                          <Col>
                            <FormGroup>
                              <label>State</label>
                              <p>
                                {details
                                  ? showDeviceStatusIcon(details.deviceLastSeen)
                                  : ""}
                              </p>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label>System Name</label>
                              <p>{details ? details.deviceName : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label>IP Address</label>
                              <p>{details ? details.deviceIp : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label>Serial Number</label>
                              <p>{details ? details.deviceSerialNumber : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label>MAC Address</label>
                              <p>{details ? details.deviceMacAddress : ""}</p>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup>
                              <label>Model</label>
                              <p>{details ? details.deviceModel : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label>Software</label>
                              <p>{details ? details.deviceFirmware : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label>Uptime</label>
                              <p>{details ? details.deviceUptime : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label>Last Seen</label>
                              <p>
                                {details
                                  ? getDeviceLastSeenInfo(
                                      details.deviceLastSeen,
                                    )
                                  : ""}
                              </p>
                            </FormGroup>
                          </Col>
                          <Col></Col>
                        </Row>
                      </Form>
                    </div>
                    <div className="d-flex gap-2">
                      <Button color="info" onClick={() => openDevicePortal()}>
                        Open Portal
                      </Button>
                      <Button
                        color="info"
                        onClick={() => redirectToDeviceDetails()}
                      >
                        View Details
                      </Button>
                      <Button
                        color="info"
                        onClick={() => redirectToConfigurationList()}
                      >
                        View Configurations
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row className="border-top pt-3 mt-3">
                  <Col md="6" className="border-end">
                    <div>
                      <h5>Endpoint Details</h5>
                      <Form>
                        <Row>
                          <Col md="3">
                            <FormGroup>
                              <label>State</label>
                              <p>{showEndpointStatusIcon(details)} </p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Name</label>
                              <p>{details ? details.confEndpointName : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Description</label>
                              <p>
                                {details ? details.confEndpointDescription : ""}
                              </p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Serial Number</label>
                              <p>{details ? details.serialNumber : ""}</p>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="3">
                            <FormGroup>
                              <label>MAC Address</label>
                              <p>{details ? details.macAddress : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Model Type</label>
                              <p>{details ? details.type : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>ASY</label>
                              <p>{details ? details.asy : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Revision</label>
                              <p>{details ? details.revision : ""}</p>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="3">
                            <FormGroup>
                              <label>Detected Port</label>
                              <p>
                                {details ? details.detectedPortIfIndex : ""}
                              </p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Configured Port</label>
                              <p>{details ? details.confPortIfIndex : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Down/Up PHY rate (Mbps)</label>
                              <p>
                                <span
                                  style={{
                                    backgroundColor: details
                                      ? details.phyColor
                                      : "",
                                  }}
                                >
                                  {details && !details.phyRate.includes("null")
                                    ? details.phyRate
                                    : ""}
                                </span>
                              </p>
                            </FormGroup>
                          </Col>
                          <Col md="3">
                            <FormGroup>
                              <label>Down/Up Max Bandwidth (Mbps)</label>
                              <p>
                                <span
                                  style={{
                                    backgroundColor: details
                                      ? details.maxColor
                                      : "",
                                  }}
                                >
                                  {details && !details.maxRate.includes("null")
                                    ? details.maxRate
                                    : ""}
                                </span>
                              </p>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="3">
                            <FormGroup>
                              <label>Uptime</label>
                              <p>{details ? details.uptime : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col></Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="d-flex gap-2">
                              {Utilities.hasAccess(
                                privileges["devices.subscribers.edit"],
                              ) &&
                              Utilities.validateLicense(
                                sessionStorage.getItem("licenseTypes"),
                                Utilities.LICENSE_PRO,
                              ) ? (
                                <Button
                                  color="info"
                                  onClick={() => redirectToSubscriberEditPage()}
                                >
                                  Edit
                                </Button>
                              ) : (
                                ""
                              )}

                              {Utilities.hasAccess(
                                privileges["devices.endpoints.reboot"],
                              ) &&
                              Utilities.validateLicense(
                                sessionStorage.getItem("licenseTypes"),
                                Utilities.LICENSE_PRO,
                              ) ? (
                                <Button
                                  color="info"
                                  onClick={() => alertReboot(details.id)}
                                  disabled={details?.reboot}
                                >
                                  Reboot
                                </Button>
                              ) : (
                                ""
                              )}

                              {Utilities.hasAccess(
                                privileges["devices.endpoints.powercycle"],
                              ) &&
                              Utilities.validateLicense(
                                sessionStorage.getItem("licenseTypes"),
                                Utilities.LICENSE_PRO,
                              ) &&
                              details &&
                              details.modelType &&
                              details.modelType.includes("PLUS") ? (
                                <Button
                                  color="info"
                                  onClick={() => alertPowerCycle(details.id)}
                                >
                                  Cycle PoE Power
                                </Button>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                  <Col md="6">
                    <div>
                      <h5>Subscriber Details</h5>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label>State</label>
                            <p>{showEndpointStatusIcon(details)} </p>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label>Name</label>
                            <p>{details ? details.subscriberName : ""}</p>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label>Description</label>
                            <p>
                              {details ? details.subscriberDescription : ""}
                            </p>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label>Bandwidth Name</label>
                            <p>
                              {details
                                ? details.bandwidthName == ""
                                  ? "Unthrottled"
                                  : details.bandwidthName
                                : ""}
                            </p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label>POE</label>
                            <p>{details ? details.poe : ""}</p>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label>VLAN Id Port #1</label>
                            <p>
                              {details ? details.vlanIdPort1 : ""}
                              {details
                                ? details.isTaggedVlan1
                                  ? ""
                                  : " (U)"
                                : ""}
                            </p>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label>VLAN Id Port #2</label>
                            <p>
                              {details ? details.vlanIdPort2 : ""}
                              {details &&
                              details.vlanIdPort2 &&
                              !details.isTaggedVlan2
                                ? " (U)"
                                : ""}
                            </p>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label>Uplink Port</label>
                            <p>{getUplinkPort()}</p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label>Allowed:Remapped Tagged VLAN</label>
                            <p>
                              {details
                                ? details.trunkMode
                                  ? "all (trunk)"
                                  : details.allowedVlan
                                : ""}
                            </p>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label>Allowed:Remapped Tagged VLAN Port #2</label>
                            <p>
                              {details
                                ? details.trunkMode
                                  ? "all (trunk)"
                                  : details.allowedVlan2
                                : ""}
                            </p>
                          </FormGroup>
                        </Col>
                        <Col></Col>
                        <Col></Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            {details && details.id ? (
              <Card>
                <CardBody>
                  <div className="nav-tabs-navigation">
                    <div className="nav-tabs-wrapper">
                      <Nav id="tabs" role="tablist" tabs>
                        <NavItem>
                          <NavLink
                            aria-expanded={horizontalTabs === "alarms"}
                            data-toggle="tab"
                            href="#"
                            role="tab"
                            className={
                              horizontalTabs === "alarms" ? "active" : ""
                            }
                            style={{ color: "black" }}
                            onClick={() => setHorizontalTabs("alarms")}
                          >
                            Alarms
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </div>

                  <TabContent
                    id="my-tab-content"
                    activeTab={horizontalTabs}
                    style={{ paddingLeft: "20px" }}
                  >
                    <TabPane tabId="alarms" role="tabpanel">
                      <ReactTable
                        query="/api/v1/endpoint/details/alarms"
                        columns={alarmsColumns}
                        title="Alarms"
                        param={details.id}
                        subtable="true"
                        className="-striped -highlight primary-pagination"
                      />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default EndpointDetails;
